<template lang='pug'>
  
	div#informacoesPonto(:class="{ 'level-1': registro }")

		//- NÍVEL 0 - Listagem de registros da camada do topo das camadas ativas

		div.float-box-view-level-0

			div.col-md-12.float-box-title

				h2.pull-left 
					i.mdi.mdi-map-marker 
					| Informações do ponto

			div.float-box-default-padding(v-show="showAlert")
				alert(:msg="mensagemErro || ''", :visible="showAlert", type="error")

			div.float-box-content

				listagem-registros(
						ref="listagemRegistros", 
						v-if="paginacaoRegistros && paginacaoRegistros.itens", 
						:registros="paginacaoRegistros.itens",
						@exibirRegistro="exibirRegistro",
						:showMarkers="false")

				empty-result.full-height(message="Nenhuma camada ativa", 
						v-if="!pesquisaEfetuada && (!camadasAtivas || !camadasAtivas.length)")

			div.float-box-footer(v-if="paginacaoRegistros && paginacaoRegistros.itens && paginacaoRegistros.itens.length > 0")
				
				paginacao(ref="paginacaoRegistros", 
						:total="paginacaoRegistros.totalItens", 
						:page-size="paginacaoRegistros.itensPorPagina", 
						:onChange="alterarPaginaRegistros", 
						:options="paginationOptions")


		//- NÍVEL 2 - Visualização dos detalhes de um registro da camada, exibido quando 
		//- o usuário clica em um dos registros na listagem

		div.float-box-view-level-1

			visualizacao-registro-camada(
					:registro="registro", 
					v-if="registro", 
					@close="ocultarRegistro()", 
					:showReturnButton="true")

</template>

<script>

import EmptyResult from '@/components/utils/EmptyResult';
import Alert from '@/components/utils/Alert';
import camadasService from '@/services/camadasService';
import ListagemRegistros from '@/components/ListagemRegistrosCamada';
import VisualizacaoRegistroCamada from '@/components/VisualizacaoRegistroCamada';
import Paginacao from '@/components/utils/Paginacao';
import markerStyles from '@/utils/markerStyles';

var requestOptions = {
	lockElement: '#informacoesPonto',
	lockMessage: 'Aguarde, buscando informações.'
};

const PAGINA_INICIAL = 1;

export default {

	name: 'InformacoesPonto',

	componentOptions: {
		
		title: 'Informacoes do Ponto',

		events: {
			'informacoesPonto.show': 'buscarInformacoesPonto'
		}
	},

	components: { EmptyResult, Alert, Paginacao, ListagemRegistros, VisualizacaoRegistroCamada },

	data () {
		return {
			wkt: null,
			msgEmptyResult: null,
			mensagemErro: '',
			pesquisaEfetuada: false,
			showAlert: false,
			registro: null,
			paginacaoRegistros: {
				itens: []
			},
			paginationOptions: {
				offset: 1,
				previousText: '«',
				nextText: '»',
				alwaysShowPrevNext: true
			}
		};
	},

	methods: {

		buscarInformacoesPonto (e) {

			if (!e || !e.latlng) return;

			this.wkt = 'POINT (' + e.latlng.lng + ' ' + e.latlng.lat + ')';

			this.adicionarMarcador(e.latlng);

			this.buscarInformacoesWktCamada();
		},

		/**
		 * Busca os registros de uma camada (grupo) selecionada na listagem de grupos.
		 */
		buscarInformacoesWktCamada (paginaAtual) {

			this.showAlert = false;
			
			if (!this.camadasAtivas || !this.camadasAtivas.length) {

				this.pesquisaEfetuada = false;
				return;
			}

			var idsCamadas = [ this.camadasAtivas[this.camadasAtivas.length - 1].id ];

			var params = {
				wkt: this.wkt,
				idsCamadas: idsCamadas,
				pagina: paginaAtual || PAGINA_INICIAL
			};

			camadasService.findInformacoesByWKT(params,
				(result) => {

					this.pesquisaEfetuada = true;
					this.paginacaoRegistros = result.data;

					if (this.paginacaoRegistros &&
							this.paginacaoRegistros.itens &&
							this.paginacaoRegistros.itens.length === 1) {
						
						this.exibirRegistro({ registro: this.paginacaoRegistros.itens[0] });
					
					} else {

						this.ocultarRegistro();
					}

				},
				this.getRequestErrorHandler(), requestOptions);
		},

		adicionarMarcador (latlng) {

			this.$bus.$emit('mapa.addCoordinatePoint', {
				markerCode: 'InformacoesPonto',
				lat: latlng.lat,
				lng: latlng.lng,
				markerStyle: markerStyles.inspecao,
				center: false,
				fixed: true
			});
		},

		removerMarcador () {

			this.$bus.$emit('mapa.removeCoordinatePoint', 'InformacoesPonto');
		},

		/**
		 * Limpa todas as ferramentas de inspeção.
		 */
		limpar () {
		
			this.ocultarRegistro();

			if (this.$refs.listagemRegistros) this.$refs.listagemRegistros.limpar();

			if (this.$refs.paginacaoRegistros) this.$refs.paginacaoRegistros.setPage(PAGINA_INICIAL);

			this.paginacaoRegistros = null;
		},

		/**
		 * Método utilizado na paginação de registros de camada para abrir uma pãgina.
		 */
		alterarPaginaRegistros (pagina) {

			this.buscarInformacoesWktCamada(pagina);
		},

		/**
		 * Exibe os detalhes de um registro.
		 */
		exibirRegistro (e) {
			
			this.registro = e.registro;
		},

		/**
		 * Oculta o registro exibido, retornando à listagem de registros de uma camada.
		 */
		ocultarRegistro () {

			this.registro = null;
		},

		/**
		 * Retorna uma função para tratar os erros de requisição.
		 */
		getRequestErrorHandler () {

			return (result) => {
				this.limpar();
				this.ocultarRegistro();
				this.mensagemErro = result.texto || 'Não foi possível efetuar a pesquisa.';
				this.showAlert = true;
			};
		},

		// Método chamado pelo componente pai (SearchBox)
		beforeComponentHide () {

			this.limpar();
			this.removerMarcador();
		}
	},

	computed: {

		camadasAtivas () {
			return this.$store.getters.camadasAtivasSig;
		}
	}
};

</script>

<style lang="scss" scoped>

#informacoesPonto {
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// InformacoesPonto.vue?22d01b0e